<template>
  <div class="roleManage">
    <div v-if="this.$route.path=='/accountManage/roleManage' || this.$route.path=='/qianchuan/account/role'">
      <div class="page-title">角色权限管理</div>
      <el-form class="query-form" label-width="50px" :model="queryForm">
        <el-form-item label="筛选">
          <el-input placeholder="请输入角色名称" v-model="queryForm.name" class="input-with-search">
            <el-button @click="getRoleManageList" slot="append" icon="iconfont icon-sousuo"></el-button>
          </el-input>
        </el-form-item>
        <div style="margin-bottom:10px;">
          <el-button  size="medium" type="primary" @click="operationRole('add')" v-permission="'role:save'" icon="iconfont icon-tianjia-copy">新增角色</el-button>
        </div>
      </el-form>
      <!-- 表格 -->
      <el-table class="center-table roleTable"
      :data="roleManageList" v-loading="tableLoading"
      border>
        <el-table-column width="80"
          prop="id" fixed
          label="角色ID">
        </el-table-column>
        <el-table-column width=""
          prop="roleName"
          label="角色名称">
        </el-table-column>
        <el-table-column width=""
          prop="describ"
          label="角色描述">
        </el-table-column>
        <el-table-column width=""
          prop="roleCode"
          label="角色类型">
        </el-table-column>
        <el-table-column width=""
          prop="createTime"
          label="创建时间">
        </el-table-column>
        <el-table-column width=""
          label="权限">
          <template slot-scope="scope">
            <el-button @click="rolePermissions(scope.row,'view')" v-if="authorityDetails" type="text" size="small">查看</el-button>
            <el-button @click="rolePermissions(scope.row,'edit')" v-if="scope.row.edit & authorityEdit" type="text" size="small">授权</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="" label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.edit">
              <el-button @click="operationRole('edit',scope.row)" v-if="editDetails" type="text" size="small">编辑</el-button>
              <el-button @click="operationRole('delete',scope.row)" v-if="roleDelete" type="text" size="small">删除</el-button>
            </div>
            <span v-else>默认不可修改</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="paging-box" v-if="pageTotal > 0">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="queryForm.pageNum"
          :page-sizes="[10, 20, 40, 80, 100]"
          @size-change="handleSizeChange"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
        </el-pagination>
      </div>
      <!-- 新增、编辑角色 -->
      <div class="operationRole">
        <el-dialog :title="operationRoleTitle" :visible.sync="operationRoleVisible" :close-on-click-modal="false" width="550px">
          <el-form ref="operationRoleRef" :model="operationRoleForm" :rules="operationRoleRules" label-width="100px">
            <el-form-item label="角色类型" prop="roleType">
              <el-select :disabled=" operationRoleType === 'edit'" v-model="operationRoleForm.roleType" filterable clearable placeholder="请选择角色类型">
                <el-option v-for="item in roleList" :key="item.id"
                :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色名称" prop="roleName">
              <el-input v-model="operationRoleForm.roleName" placeholder="请输入角色名称" maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="角色描述" prop="roleDescription">
              <el-input type="textarea" :rows="4" placeholder="请输入角色描述" v-model="operationRoleForm.roleDescription" maxlength="50" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button size="small" @click="operationRoleVisible=false">取 消</el-button>
            <el-button type="primary" size="small" @click="operationRoleSubmit" v-permission="'role:edit'">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
// 表单验证
import { notNullable, notNullableChange } from '@/components/form/formValidation'
// 公用
import { getTimeAll } from '@/components/public'
export default {
  name: 'roleManage',
  data () {
    return {
      authorityEdit: false, // 授权权限
      authorityDetails: false, // 查看权限
      editDetails: false, // 编辑权限
      roleDelete: false, // 删除权限
      tableLoading: true,
      operationRoleType: '', // 按钮类型
      roleManageList: [],
      // 查询表单
      queryForm: {
        name: '',
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      // 分页
      pageTotal: 0,
      // 角色列表
      roleList: [],
      // 新增、编辑角色弹框
      operationRoleVisible: false,
      operationRoleForm: {
        id: '',
        roleType: '',
        roleName: '',
        roleDescription: ''
      },
      operationRoleRules: {
        roleType: [
          notNullableChange('请选择角色类型')
        ],
        roleName: [
          notNullable('请填写角色名称')
        ]
      },
      operationRoleTitle: ''
    }
  },
  created () {
    this.authorityEdit = this.checkPermission('role:authority:edit')
    this.authorityDetails = this.checkPermission('role:authority:details')
    this.editDetails = this.checkPermission('role:edit:details')
    this.roleDelete = this.checkPermission('role:delete')
    this.getRoleManageList()
    this.getRoleList()
  },
  mounted () {
  },
  watch: {
    // 弹框重置表单
    operationRoleVisible (to, form) {
      if (to === false) {
        this.$nextTick(() => {
          this.$refs.operationRoleRef.resetFields()
        })
      }
    }
  },
  methods: {
    // 获取查询数据
    getRoleManageList () {
      // 开启tableLoading
      this.tableLoading = true
      this.$service.post('/api/role/list', this.queryForm).then(res => {
        if (res.code === 200) {
          if (res.result.pageData) {
            res.result.pageData.forEach(item => {
              item.edit === 0 ? item.edit = false : item.edit = true
              item.createTime = getTimeAll(new Date(item.createTime))
              item.roleCode = this.getRoleType(item.roleCode)
            })
            this.roleManageList = res.result.pageData
          }
          this.pageTotal = res.result.total
          this.tableLoading = false
        }
      }).catch(Err => {
        this.tableLoading = false
        console.log(Err)
      })
    },
    rolePermissions (row, type) {
      let path = ''
      if (this.$route.path.startsWith('/qianchuan')) {
        path = '/qianchuan/account/role/roleAuthorization'
      } else {
        path = '/accountManage/roleManage/roleAuthorization'
      }
      this.$router.push({path: path, query: {'type': type, 'id': row.id, 'name': row.roleName}})
    },
    getRoleType(code) {
      if (code === 'admin') {
        return '超级管理员'
      } else if (code === 'Optimizing_master') {
        return '优化师主管'
      } else if (code === 'Optimizing') {
        return '优化师'
      } else if (code === 'ui_master') {
        return '设计师主管'
      } else if (code === 'ui') {
        return '设计师'
      } else if (code === 'producer') {
        return '编导'
      } else if (code === 'camera') {
        return '摄像'
      } else if (code === 'cutter') {
        return '剪辑'
      }
    },
    getRoleList() {
      this.roleList = [{
        name: '优化师主管类',
        code: 'Optimizing_master'
      }, {
        name: '优化师类',
        code: 'Optimizing'
      }, {
        name: '设计师主管类',
        code: 'ui_master'
      }, {
        name: '设计师类',
        code: 'ui'
      }, {
        name: '编导类',
        code: 'producer'
      }, {
        name: '摄像类',
        code: 'camera'
      }, {
        name: '剪辑类',
        code: 'cutter'
      }]
    },
    // 操作角色
    operationRole(type, item) {
      this.operationRoleType = type
      if (type === 'delete') {
        this.$confirm('确认删除当前角色?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$service.post('/api/role/delete', {'id': item.id}).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getRoleManageList() // 刷新列表
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          }).catch(Err => {})
        }).catch(() => {})
      } else {
        if (type === 'edit') {
          this.operationRoleTitle = '编辑角色权限'
          this.$service.post('/api/role/edit/details', {'id': item.id}).then(res => {
            if (res.code === 200) {
              this.operationRoleForm.id = res.result.id
              this.operationRoleForm.roleType = res.result.roleCode
              this.operationRoleForm.roleName = res.result.roleName
              this.operationRoleForm.roleDescription = res.result.describ
            }
          }).catch(Err => {})
        } else if (type === 'add') {
          this.operationRoleTitle = '新建角色'
        }
        this.operationRoleVisible = true
      }
    },
    // 提交新增、编辑角色
    operationRoleSubmit () {
      this.$refs.operationRoleRef.validate(valid => {
        if (valid) {
          if (this.operationRoleType === 'add') { // 新建提交
            let param = {
              code: this.operationRoleForm.roleType,
              describ: this.operationRoleForm.roleDescription,
              name: this.operationRoleForm.roleName
            }
            this.$service.post('/api/role/save', param).then(res => {
              this.$message({
                showClose: true,
                message: '新建成功！',
                type: 'success'
              })
              // 刷新列表
              this.getRoleManageList()
              this.operationRoleVisible = false
            }).catch(Err => {})
          } else { // 修改提交
            let param = {
              id: this.operationRoleForm.id,
              code: this.operationRoleForm.roleType,
              describ: this.operationRoleForm.roleDescription,
              name: this.operationRoleForm.roleName
            }
            this.$service.post('/api/role/edit', param).then(res => {
              this.$message({
                showClose: true,
                message: '修改成功！',
                type: 'success'
              })
              // 刷新列表
              this.getRoleManageList()
              this.operationRoleVisible = false
            }).catch(Err => {
            })
          }
        }
      })
    },
    // 切换分页
    handleCurrentChange (currentPage) {
      this.queryForm.pageNum = currentPage
      this.getRoleManageList()
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.getRoleManageList()
    }
  },
  computed: {
  }
}
</script>

<style lang="less">
.roleManage{
  .operationRole{
    .el-dialog{
      margin-top: 25vh;
      .el-dialog__body{
        padding-bottom: 0;
        .el-select{
          .el-input{
            width: 350px;
          }
        }
        .el-input{
            width: 350px;
        }
        .el-textarea{
          width: 350px;
        }
      }
    }
  }
  // .bgfff.el-button--info{
  //   background-color: #fff;
  // }
  // .bgfff.el-button--info.is-disabled{
  //   color: #999;
  // }
  // .el-button--info.is-disabled:hover {
  //   background-color: #fff;
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/accountManage/roleManage.vue